import {Add} from "@mui/icons-material";
import React from "react";
import {Business, Industry, Pricing, Product} from "../../../firebase/index.js";
import {APXHideOnScrollFab} from "../../../reusables/APXHideOnScrollFab.jsx";
import {productColour, white} from "../../../reusables/js/APXTheme.js";
import {nonPlusLimits, useInMemoryPlusStatus} from "../../../reusables/plus/APXPlus.js";
import {APXPlusRequiredAlert} from "../../../reusables/plus/APXPlusAlerts.jsx";
import AddNewProductBSL from "./AddNewProductBSL.jsx";
import ProductCard from "./ProductCard.jsx";


export default function ProductsLayout({uid, i, ps, pps, bs}: { uid: string, i: Industry, ps: Product[], pps: Pricing[], bs: Business[] }) {
	  const products: Product[] = ps || [];
	  const pricings: Pricing[] = pps || [];
	  const businesses: Business[] = bs || [];
	  
	  const [openNewProductBSL, setOpenNewProductBSL] = React.useState(false);
	  
	  const {isPlusUser} = useInMemoryPlusStatus();
	  
	  return (
				 <>
						{
							  products.map((pro) =>
										 <ProductCard key={pro.getKey()}
														  uid={uid}
														  i={i}
														  p={pro}
														  ps={pricings.filter((pri) => pri.productKey === pro.getKey())}
														  bs={businesses}
										 />
							  )
						}
						<APXHideOnScrollFab icon={<Add/>} backgroundColour={productColour} colour={white}
												  sx={{position: "fixed", bottom: 16, right: 16}}
												  onClick={() => setOpenNewProductBSL(true)}
						/>
						{openNewProductBSL ?
								  (
											 (isPlusUser)
											 ||
											 (/*NOT->*/ !isPlusUser && /*TRUTHY->*/ !!products && products.length < nonPlusLimits.pro.numerical)
								  ) ?
											 <AddNewProductBSL uid={uid} industryKey={i.industryKey} existingProducts={products} onClose={() => setOpenNewProductBSL(false)}/>
											 :
											 <APXPlusRequiredAlert/>
								  :
								  null
						}
				 </>
	  );
}
